<script setup>
import { computed, onMounted, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute, useRouter } from 'vue-router'
import { useNotificationsStore } from '@/modules/notifications/stores/notifications.store'
import DssNotificationsDropdown from './dss-notifications-dropdown.vue'

const { t } = useI18n()
const route = useRoute()
const router = useRouter()
const notificationsStore = useNotificationsStore()

const popover = ref()

const badgeLabel = computed(() =>
  notificationsStore.unreadCount > 99 ? '99+' : String(notificationsStore.unreadCount),
)

function toggleDropdown(event) {
  popover.value.toggle(event)
}

function handleShow() {
  notificationsStore.refresh()
}

function handleViewAll() {
  popover.value.hide()
  router.push('/notifications')
}

function handleNavigated() {
  popover.value.hide()
}

onMounted(() => {
  notificationsStore.loadUnreadCount()
})

watch(() => route.fullPath, () => {
  notificationsStore.loadUnreadCount()
})
</script>

<template>
  <div class="relative flex items-center">
    <Button
      v-tooltip.bottom="t('core.header.tooltips.notifications')"
      icon="pi pi-bell"
      class="w-11! h-11! p-0! bg-dss-surface-200 hover:bg-dss-surface-250 transition-colors duration-200 rounded-2xl border-0 focus:outline-none focus:ring-0 transform-gpu will-change-transform text-dss-secondary-500"
      :aria-label="t('core.header.tooltips.notifications')"
      @click="toggleDropdown"
    />
    <span
      v-if="notificationsStore.hasUnread"
      class="absolute -top-1 -right-1 min-w-4.5 h-4.5 px-1 rounded-full bg-red-500 dark:bg-red-400 text-white text-[0.625rem] font-semibold flex items-center justify-center pointer-events-none"
    >
      {{ badgeLabel }}
    </span>
  </div>

  <Popover
    ref="popover"
    class="p-0! rounded-2xl drop-shadow before:hidden after:hidden"
    @show="handleShow"
  >
    <dss-notifications-dropdown
      @view-all="handleViewAll"
      @navigated="handleNavigated"
    />
  </Popover>
</template>
